module.exports = "print(src: \"Hello World\")"